import { map, defaultArg } from "../../../fable_modules/fable-library.3.7.20/Option.js";
import { sumBy, map as map_1, length, ofArray, singleton as singleton_2, empty, tryFind } from "../../../fable_modules/fable-library.3.7.20/List.js";
import { toString as toString_1, Record } from "../../../fable_modules/fable-library.3.7.20/Types.js";
import { class_type, list_type, int32_type, record_type, lambda_type, unit_type, string_type } from "../../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Locale_get_FromSelectedLanguage, DateOnlyExtensions_toDate, decimalToTwoDecimals, logei, DateTimeOffsetExtensions_toDateHHmmss, stackClasses, Locale$reflection } from "../../../Utils.js";
import { renderFileImportState, StatisticsItem$reflection, FileImportState_OfFileImport_Z76481C2E, FileImport$reflection } from "../Common.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { renderModal } from "../../../Components/Modals/Choice/Choice.js";
import { dotsLoading, Size, getMaterialIconBySize, getWrappedMaterialIcon, getMaterialIcon } from "../../../ViewUtils.js";
import { singleton, append, delay, toList } from "../../../fable_modules/fable-library.3.7.20/Seq.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library.3.7.20/Choice.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { int16ToString, int32ToString, uncurry } from "../../../fable_modules/fable-library.3.7.20/Util.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { DropDownButtonProps, dropDownButton, ButtonProps, defaultProps } from "../../../Components/Button/Button.js";
import { startImmediate } from "../../../fable_modules/fable-library.3.7.20/Async.js";
import { loadUpdatedAddress, loadFeeAttributes as loadFeeAttributes_1, loadContractAttributes as loadContractAttributes_1, loadUpdatedFees as loadUpdatedFees_1, loadUpdatedContracts as loadUpdatedContracts_1, loadUpdatedInvoicees as loadUpdatedInvoicees_1, loadConsumptionFees as loadConsumptionFees_1, loadNewFees as loadNewFees_1, loadNewContracts as loadNewContracts_1, loadNewInvoicees as loadNewInvoicees_1, loadSingleFileImport as loadSingleFileImport_1, getUpdatedAddressUrl, getFeeAttributesUrl, getContractAttributesUrl, getUpdatedFeesUrl, getUpdatedContractsUrl, getUpdatedInvoiceesUrl, getConsumptionFeesUrl, getNewContractsUrl, getNewInvoiceesUrl, reject, update, approve } from "./Api.js";
import { singleton as singleton_1 } from "../../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { HTMLAttr } from "../../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { printf, toText } from "../../../fable_modules/fable-library.3.7.20/String.js";
import { UTC__toDateTimeOffset } from "../../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { ValidatedUrl__get_Value } from "../../../HttpV2.js";
import { PageinationProps$1, Pagination } from "../../../Components/Pagination/Pagination.js";
import { CollapseLeftProps, CollapseLeftProps_get_GetDefault, collapseLeft } from "../../../Components/Collapse/Collapse.js";
import { renderTable } from "../../../Components/Table/Table.js";
import { op_Multiply, op_Addition, toNumber } from "../../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../../fable_modules/fable-library.3.7.20/Decimal.js";
import { toNumber as toNumber_1, toString } from "../../../fable_modules/fable-library.3.7.20/Long.js";
import { separateByThousands } from "../../../Utilities/String.js";
import { loadEffect, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../../Global.js";
import { useDispatch, useSelector } from "../../../Redux/Store.js";
import { warning, error } from "../../../Components/Message/Message.js";
import { error as error_1 } from "../../../Redux/Reducers/ModalsReducer.js";
import { renderLoadState } from "../../../Components/Misc/Misc.js";
import "../../../../src/Containers/FileImport/Details/View.scss";


function getTopicValueFromStatistics(statistics, name) {
    return defaultArg(map((m) => m.value, tryFind((s) => (s.name === name), statistics)), 0);
}

class TopSectionModalProps extends Record {
    constructor(Header, Body, OnClick) {
        super();
        this.Header = Header;
        this.Body = Body;
        this.OnClick = OnClick;
    }
}

function TopSectionModalProps$reflection() {
    return record_type("Containers.FileImport.Details.View.TopSectionModalProps", [], TopSectionModalProps, () => [["Header", string_type], ["Body", string_type], ["OnClick", lambda_type(unit_type, unit_type)]]);
}

class TopSectionProps extends Record {
    constructor(GetTranslation, ShowMsgFn, Locale, ClientNr, BulkImportId, FileImport, ReloadFn) {
        super();
        this.GetTranslation = GetTranslation;
        this.ShowMsgFn = ShowMsgFn;
        this.Locale = Locale;
        this.ClientNr = (ClientNr | 0);
        this.BulkImportId = (BulkImportId | 0);
        this.FileImport = FileImport;
        this.ReloadFn = ReloadFn;
    }
}

function TopSectionProps$reflection() {
    return record_type("Containers.FileImport.Details.View.TopSectionProps", [], TopSectionProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["ShowMsgFn", lambda_type(string_type, unit_type)], ["Locale", Locale$reflection()], ["ClientNr", int32_type], ["BulkImportId", int32_type], ["FileImport", FileImport$reflection()], ["ReloadFn", lambda_type(unit_type, unit_type)]]);
}

const topSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let props_28, children_27, props_24, children_23, children_21, children_49, children_39, children_35, children_33, props_34, children_31, children_37, children_47, children_41, children_43, children_45;
    const modalOpenState = react.useState(void 0);
    let modalHtml;
    const matchValue = modalOpenState[0];
    if (matchValue != null) {
        const modalProps = matchValue;
        modalHtml = renderModal(modalProps.Header, react.createElement("div", {
            className: "p-4",
        }, modalProps.Body), props.GetTranslation("Common.Cancel"), props.GetTranslation("Common.Ok"), (_arg) => {
            modalOpenState[1](void 0);
        }, (_arg_1) => {
            modalProps.OnClick();
            modalOpenState[1](void 0);
        });
    }
    else {
        modalHtml = react.createElement(react.Fragment, {});
    }
    const renderBoxTop = (icon, text) => {
        let children_7, children_3;
        const children_9 = [(children_7 = [(children_3 = [getMaterialIcon(icon)], react.createElement("span", {
            className: "top__icon",
        }, ...children_3)), react.createElement("span", {
            className: "top__text",
        }, text)], react.createElement("div", {
            className: "d-flex",
        }, ...children_7))];
        return react.createElement("div", {
            className: "box__top",
        }, ...children_9);
    };
    const renderBoxBottom = (content, hrefOpt) => {
        const children_18 = toList(delay(() => append(singleton(react.createElement("span", {}, content)), delay(() => {
            let children_16, children_14;
            const matchValue_1 = hrefOpt;
            if (matchValue_1 != null) {
                const href = matchValue_1;
                return singleton((children_16 = [(children_14 = [getWrappedMaterialIcon("open_in_new")], react.createElement("a", {
                    href: href,
                    target: "_blank",
                }, ...children_14))], react.createElement("span", {}, ...children_16)));
            }
            else {
                return singleton(react.createElement(react.Fragment, {}));
            }
        }))));
        return react.createElement("div", {
            className: "box__bottom",
        }, ...children_18);
    };
    const fileImportState = FileImportState_OfFileImport_Z76481C2E(props.FileImport);
    let statisticsResult;
    const matchValue_2 = props.FileImport.StatisticsJson;
    if (matchValue_2 == null) {
        statisticsResult = (new FSharpResult$2(0, empty()));
    }
    else {
        const escapedJson = matchValue_2;
        statisticsResult = fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(StatisticsItem$reflection()), new CaseStrategy(1), void 0)), escapedJson);
    }
    const getTopicValue = (name) => {
        if (statisticsResult.tag === 1) {
            return 0;
        }
        else {
            return getTopicValueFromStatistics(statisticsResult.fields[0], name) | 0;
        }
    };
    const statusHtml = renderFileImportState(props.ShowMsgFn, props.Locale, props.FileImport);
    let topDropdownButtonHtml;
    const approveButtonProps = new ButtonProps(props.GetTranslation("Import.ImportProgram.Details.Approve"), defaultProps.Content, (_arg_2) => {
        const arg_2 = new TopSectionModalProps(props.GetTranslation("Import.ImportProgram.Approve.Header"), props.GetTranslation("Import.ImportProgram.Approve.BodyText"), () => {
            let a;
            startImmediate((a = approve(props.ClientNr, props.BulkImportId), singleton_1.Delay(() => singleton_1.Bind(a, (_arg_3) => singleton_1.Return(void _arg_3)))));
            props.ReloadFn();
            modalOpenState[1](void 0);
        });
        modalOpenState[1](arg_2);
    }, defaultProps.Disabled, "top-btn-approve", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const updateButtonProps = new ButtonProps(props.GetTranslation("Import.ImportProgram.Details.Update"), defaultProps.Content, (_arg_4) => {
        const arg_5 = new TopSectionModalProps(props.GetTranslation("Import.ImportProgram.Update.Header"), props.GetTranslation("Import.ImportProgram.Update.BodyText"), () => {
            let a_2;
            startImmediate((a_2 = update(props.ClientNr, props.BulkImportId), singleton_1.Delay(() => singleton_1.Bind(a_2, (_arg_5) => singleton_1.Return(void _arg_5)))));
            props.ReloadFn();
            modalOpenState[1](void 0);
        });
        modalOpenState[1](arg_5);
    }, defaultProps.Disabled, "top-btn-update", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const rejectButtonProps = new ButtonProps(props.GetTranslation("Import.ImportProgram.Details.Reject"), defaultProps.Content, (_arg_6) => {
        const arg_8 = new TopSectionModalProps(props.GetTranslation("Import.ImportProgram.Reject.Header"), props.GetTranslation("Import.ImportProgram.Reject.BodyText"), () => {
            let a_4;
            startImmediate((a_4 = reject(props.ClientNr, props.BulkImportId), singleton_1.Delay(() => singleton_1.Bind(a_4, (_arg_7) => singleton_1.Return(void _arg_7)))));
            props.ReloadFn();
            modalOpenState[1](void 0);
        });
        modalOpenState[1](arg_8);
    }, defaultProps.Disabled, "top-btn-reject", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    switch (fileImportState.tag) {
        case 0:
        case 7:
        case 8: {
            topDropdownButtonHtml = dropDownButton(new DropDownButtonProps("top-dropdown-btn", props.GetTranslation("Import.ImportProgram.Details.MoreActions"), singleton_2(updateButtonProps)));
            break;
        }
        case 4:
        case 2:
        case 1:
        case 6:
        case 3: {
            topDropdownButtonHtml = react.createElement(react.Fragment, {});
            break;
        }
        default: {
            topDropdownButtonHtml = dropDownButton(new DropDownButtonProps("top-dropdown-btn", props.GetTranslation("Import.ImportProgram.Details.MoreActions"), ofArray([approveButtonProps, updateButtonProps, rejectButtonProps])));
        }
    }
    const children_51 = [modalHtml, (props_28 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between", "align-items-center"])))], (children_27 = [(props_24 = [new HTMLAttr(65, stackClasses(singleton_2("d-flex")))], (children_23 = [getMaterialIconBySize("insert_drive_file", new Size(3)), (children_21 = [props.GetTranslation("Import.ImportProgram.Details.FileImportSummary")], react.createElement("span", {
        className: "ml-2",
    }, ...children_21))], react.createElement("h2", keyValueList(props_24, 1), ...children_23))), react.createElement("div", {
        className: "file-import-details__container",
    }, statusHtml, topDropdownButtonHtml)], react.createElement("div", keyValueList(props_28, 1), ...children_27))), react.createElement("hr", {}), (children_49 = [(children_39 = [(children_35 = [renderBoxTop("description", props.GetTranslation("Import.ImportProgram.Details.FileName")), (children_33 = [(props_34 = [new HTMLAttr(94, toText(printf("/FileImport/%d/Download/%d"))(props.ClientNr)(props.BulkImportId)), new HTMLAttr(80, props.FileImport.BulkImportName), new HTMLAttr(158, props.GetTranslation("Import.ImportProgram.Details.Download"))], (children_31 = [react.createElement("i", {
        className: "material-icons",
    }, "download"), props.FileImport.BulkImportName], react.createElement("a", keyValueList(props_34, 1), ...children_31)))], react.createElement("div", {
        className: "file-container__download",
    }, ...children_33))], react.createElement("div", {
        className: "file-container__box",
    }, ...children_35)), (children_37 = [renderBoxTop("event_available", props.GetTranslation("Import.ImportProgram.Details.ImportDate")), renderBoxBottom(DateTimeOffsetExtensions_toDateHHmmss(props.Locale.ILocale, UTC__toDateTimeOffset(props.FileImport.CreatedAtUtc)), void 0)], react.createElement("div", {
        className: "file-container__box",
    }, ...children_37))], react.createElement("div", {
        className: "file-import-details__file-row",
    }, ...children_39)), (children_47 = [(children_41 = [renderBoxTop("mail", props.GetTranslation("Import.ImportProgram.Details.Messages")), renderBoxBottom(int32ToString(getTopicValue("Messages")), toText(printf("#/Rapporter/import_messages?BulkImportId=%i"))(props.BulkImportId))], react.createElement("div", {
        className: "file-container__box",
    }, ...children_41)), (children_43 = [renderBoxTop("warning", props.GetTranslation("Import.ImportProgram.Details.Warnings")), renderBoxBottom(int32ToString(getTopicValue("Warnings")), toText(printf("#/Rapporter/import_warnings?BulkImportId=%i"))(props.BulkImportId))], react.createElement("div", {
        className: "file-container__box",
    }, ...children_43)), (children_45 = [renderBoxTop("cancel", props.GetTranslation("Import.ImportProgram.Details.Errors")), renderBoxBottom(int32ToString(getTopicValue("Errors")), toText(printf("#/Rapporter/import_errors?BulkImportId=%i"))(props.BulkImportId))], react.createElement("div", {
        className: "file-container__box",
    }, ...children_45))], react.createElement("div", {
        className: "file-import-details__file-row",
    }, ...children_47))], react.createElement("div", {
        className: "file-import-details__file-container",
    }, ...children_49))];
    return react.createElement("div", {
        className: "file-import-details__top-section",
    }, ...children_51);
}, "FileImportTopSection", uncurry(2, void 0), void 0, "topSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FileImport\\Details\\View.fs", 230);

function renderDownloadButton(getTranslation, getUrlFn, prefixId) {
    const getUrl = (format) => {
        const matchValue = getUrlFn();
        if (matchValue.tag === 1) {
            logei(matchValue.fields[0]);
            return "";
        }
        else {
            return ValidatedUrl__get_Value(matchValue.fields[0]) + format;
        }
    };
    let dropdownButtonHtml;
    const csvButtonProps = new ButtonProps("CSV", defaultProps.Content, (_arg) => {
        window.location.assign(getUrl("csv"));
    }, defaultProps.Disabled, toText(printf("%s-dropdown-btn-csv"))(prefixId), defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    const slkButtonProps = new ButtonProps("SLK", defaultProps.Content, (_arg_1) => {
        window.location.assign(getUrl("slk"));
    }, defaultProps.Disabled, toText(printf("%s-dropdown-btn-csv"))(prefixId), defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
    dropdownButtonHtml = dropDownButton(new DropDownButtonProps("new-invoicees-dropdown-btn", getTranslation("Common.Download"), ofArray([csvButtonProps, slkButtonProps])));
    const children_2 = [react.createElement("div", {
        className: "collapse-heading__right",
    }, dropdownButtonHtml)];
    return react.createElement("div", {
        className: "file-import-details__collapse-heading",
    }, ...children_2);
}

function renderTableWithCollapseAndDownload(getTranslation, getUrlFn, renderTableFn, tableName, rows) {
    let children_3, children_1, arg_1, inputRecord, props_7;
    const nrOfRows = length(rows) | 0;
    let collapseHeadingRightHtml;
    const downloadButtonHtml = (nrOfRows === 0) ? react.createElement(react.Fragment, {}) : renderDownloadButton(getTranslation, getUrlFn, "new-invoicee");
    const children_5 = [(children_3 = [(children_1 = [(arg_1 = getTranslation("Common.Rows"), toText(printf("%i %s"))(nrOfRows)(arg_1))], react.createElement("div", {
        className: "mb-2",
    }, ...children_1)), downloadButtonHtml], react.createElement("div", {
        className: "collapse-heading__right",
    }, ...children_3))];
    collapseHeadingRightHtml = react.createElement("div", {
        className: "file-import-details__collapse-heading",
    }, ...children_5);
    const tableHtml = Pagination()(new PageinationProps$1(renderTableFn, rows, 10, 0));
    return collapseLeft((inputRecord = CollapseLeftProps_get_GetDefault(), new CollapseLeftProps(tableHtml, (props_7 = [new HTMLAttr(65, stackClasses(ofArray(["ml-2", "mb-2"])))], react.createElement("h5", keyValueList(props_7, 1), tableName)), collapseHeadingRightHtml, nrOfRows !== 0)));
}

function renderNewInvoiceesTable(getTranslation, clientNr, bulkImportId, newInvoicees) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getNewInvoiceesUrl(clientNr, bulkImportId), (newInvoicees_1) => renderTable(ofArray(["InvoiceeBulkRef", "CrossRef", "Name", "OrgNr", "Email", "PhoneNr", "Street", "PostalCode", "PostalCity", "Country", "DistributionCode"]), map_1((newInvoicee) => ofArray([defaultArg(map(int32ToString, newInvoicee.InvoiceeBulkRef), ""), defaultArg(newInvoicee.CrossRef, ""), newInvoicee.Name, newInvoicee.OrganizationNr, defaultArg(newInvoicee.Email, ""), defaultArg(newInvoicee.ContactPhoneNumber, ""), newInvoicee.Street, newInvoicee.PostalCode, newInvoicee.PostalCity, newInvoicee.Country, newInvoicee.DistributionCode.toString()]), newInvoicees_1)), "New Invoicees", newInvoicees);
}

function renderNewContractsTable(getTranslation, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getNewContractsUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["InvoiceeBulkRef", "ContractBulkRef", "ContractTypeCode", "ContractCrossReference", "EndUser"]), map_1((row) => ofArray([defaultArg(map(int32ToString, row.InvoiceeBulkRef), ""), int32ToString(row.ContractBulkRef), row.ContractTypeCode, defaultArg(row.ContractCrossReference, ""), row.EndUser]), rows_1)), "New Contracts", rows);
}

function renderNewFeesTable(getTranslation, locale, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getNewContractsUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["ContractNr", "ContractBulkRef", "Description", "Fee", "VatRatePercent", "StartDate", "Period", "MonthsInAdvance", "AccountNo", "BoundToDate", "CancellationPeriodMonths", "CancelledDate", "FeeType"]), map_1((row) => ofArray([defaultArg(map(int32ToString, row.ContractNr), ""), defaultArg(map(int32ToString, row.ContractBulkRef), ""), row.Description, decimalToTwoDecimals(row.Fee), int32ToString(~(~toNumber(row.VatRatePercent))), DateOnlyExtensions_toDate(locale.ILocale, row.StartDate), row.Period.toString(), int16ToString(row.MonthsInAdvance), int32ToString(row.AccountNo), defaultArg(map((date_1) => DateOnlyExtensions_toDate(locale.ILocale, date_1), row.BoundToDate), ""), row.CancellationPeriodMonths.toString(), defaultArg(map((date_2) => DateOnlyExtensions_toDate(locale.ILocale, date_2), row.CancelledDate), ""), row.FeeType.toString()]), rows_1)), "New Fees", rows);
}

function renderConsumptionFeesTable(getTranslation, locale, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getConsumptionFeesUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["ContractNr", "ContractBulkRef", "Description", "Volume", "ChargePerUnit", "ChargeUnit", "VatPercentage", "Unit", "PeriodFrom", "PeriodTo", "AccountNo", "Source", "FeeRef"]), map_1((row) => ofArray([defaultArg(map(int32ToString, row.ContractNr), ""), defaultArg(map(int32ToString, row.ContractBulkRef), ""), row.Description, toString(row.Volume), decimalToTwoDecimals(row.ChargePerUnit), toString(row.ChargeUnit), decimalToTwoDecimals(row.VatPercentage), row.Unit, defaultArg(map((date) => DateOnlyExtensions_toDate(locale.ILocale, date), row.PeriodFrom), ""), defaultArg(map((date_1) => DateOnlyExtensions_toDate(locale.ILocale, date_1), row.PeriodTo), ""), int32ToString(row.AccountNo), row.Source, defaultArg(row.FeeRef, "")]), rows_1)), "Consumption Fees", rows);
}

function renderUpdatedInvoiceesTable(getTranslation, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getUpdatedInvoiceesUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["InvoiceeNr", "Name", "Email", "ContactPhoneNumber", "DistributionCode", "PaymentTermsNetDays", "IsInbetalningsavi"]), map_1((row) => ofArray([toString(row.InvoiceeNr), defaultArg(row.Name, ""), defaultArg(row.Email, ""), defaultArg(row.ContactPhoneNumber, ""), defaultArg(map((value_3) => value_3.toString(), row.DistributionCode), ""), defaultArg(map((value_5) => value_5.toString(), row.PaymentTermsNetDays), ""), defaultArg(map(toString_1, row.IsInbetalningsavi), "")]), rows_1)), "Updated Invoicees", rows);
}

function renderUpdatedContractsTable(getTranslation, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getUpdatedContractsUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["ContractNr", "EndUser"]), map_1((row) => ofArray([int32ToString(row.ContractNr), row.EndUser]), rows_1)), "Updated Contracts", rows);
}

function renderUpdatedFeesTable(getTranslation, locale, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getUpdatedFeesUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["FeeNr", "Description", "Fee", "VatRatePercent", "StartDate", "Period", "MonthsInAdvance", "AccountNo", "BoundToDate", "CancellationPeriodMonths", "CancelledDate", "FeeType"]), map_1((row) => ofArray([int32ToString(row.FeeNr), row.Description, decimalToTwoDecimals(row.Fee), decimalToTwoDecimals(row.VatRatePercent), DateOnlyExtensions_toDate(locale.ILocale, row.StartDate), row.Period.toString(), int16ToString(row.MonthsInAdvance), int32ToString(row.AccountNo), defaultArg(map((date_1) => DateOnlyExtensions_toDate(locale.ILocale, date_1), row.BoundToDate), ""), row.CancellationPeriodMonths.toString(), defaultArg(map((date_2) => DateOnlyExtensions_toDate(locale.ILocale, date_2), row.CancelledDate), ""), row.FeeType.toString()]), rows_1)), "Updated Fees", rows);
}

function renderContractAttributesTable(getTranslation, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getContractAttributesUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["ContractNr", "ContractBulkRef", "Key", "Value"]), map_1((row) => ofArray([defaultArg(map(int32ToString, row.ContractNr), ""), defaultArg(map(int32ToString, row.ContractBulkRef), ""), row.Key, row.Value]), rows_1)), "Contract Attributes", rows);
}

function renderFeeAttributesTable(getTranslation, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getFeeAttributesUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["BulkRef", "Key", "Value"]), map_1((row) => ofArray([int32ToString(row.BulkRef), row.Key, row.Value]), rows_1)), "Fee Attributes", rows);
}

function renderUpdatedAddressesTable(getTranslation, clientNr, bulkImportId, rows) {
    return renderTableWithCollapseAndDownload(getTranslation, () => getUpdatedAddressUrl(clientNr, bulkImportId), (rows_1) => renderTable(ofArray(["InvoiceeNr", "Attention", "Street", "PostalCode", "PostalCity", "Country"]), map_1((row) => ofArray([toString(row.InvoiceeNr), row.Attention, row.Street, row.PostalCode, row.PostalCity, row.Country]), rows_1)), "Updated Addresses", rows);
}

class SummaryProps extends Record {
    constructor(GetTranslation, NewFeesTotal, UpdatedFeesTotal, ConsumptionFeesTotal, NrOfNewInvoicees, NrOfNewContracts, NrOfNewFees, NrOfConsumptionFees, NrOfUpdatedInvoicees, NrOfUpdatedContracts, NrOfUpdatedFees, NrOfContractAttributes, NrOfFeeAttributes, NrOfUpdatedAddresses) {
        super();
        this.GetTranslation = GetTranslation;
        this.NewFeesTotal = NewFeesTotal;
        this.UpdatedFeesTotal = UpdatedFeesTotal;
        this.ConsumptionFeesTotal = ConsumptionFeesTotal;
        this.NrOfNewInvoicees = (NrOfNewInvoicees | 0);
        this.NrOfNewContracts = (NrOfNewContracts | 0);
        this.NrOfNewFees = (NrOfNewFees | 0);
        this.NrOfConsumptionFees = (NrOfConsumptionFees | 0);
        this.NrOfUpdatedInvoicees = (NrOfUpdatedInvoicees | 0);
        this.NrOfUpdatedContracts = (NrOfUpdatedContracts | 0);
        this.NrOfUpdatedFees = (NrOfUpdatedFees | 0);
        this.NrOfContractAttributes = (NrOfContractAttributes | 0);
        this.NrOfFeeAttributes = (NrOfFeeAttributes | 0);
        this.NrOfUpdatedAddresses = (NrOfUpdatedAddresses | 0);
    }
}

function SummaryProps$reflection() {
    return record_type("Containers.FileImport.Details.View.SummaryProps", [], SummaryProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["NewFeesTotal", class_type("System.Decimal")], ["UpdatedFeesTotal", class_type("System.Decimal")], ["ConsumptionFeesTotal", class_type("System.Decimal")], ["NrOfNewInvoicees", int32_type], ["NrOfNewContracts", int32_type], ["NrOfNewFees", int32_type], ["NrOfConsumptionFees", int32_type], ["NrOfUpdatedInvoicees", int32_type], ["NrOfUpdatedContracts", int32_type], ["NrOfUpdatedFees", int32_type], ["NrOfContractAttributes", int32_type], ["NrOfFeeAttributes", int32_type], ["NrOfUpdatedAddresses", int32_type]]);
}

function renderSummary(props) {
    let props_17, children_16, children_12, children_14, children_30, children_22, children_18, children_20, children_28, children_24, children_26;
    const renderFeeTotal = (text, total) => {
        let children_2;
        const children_4 = [react.createElement("div", {
            className: "total__fee-text",
        }, text), (children_2 = [separateByThousands(decimalToTwoDecimals(total))], react.createElement("div", {
            className: "total__fee-total",
        }, ...children_2))];
        return react.createElement("div", {
            className: "fees__total",
        }, ...children_4);
    };
    const renderCount = (text_1, count) => {
        let children_8;
        const children_10 = [react.createElement("div", {
            className: "counts__header",
        }, text_1), (children_8 = [separateByThousands(int32ToString(count))], react.createElement("div", {
            className: "counts__total",
        }, ...children_8))];
        return react.createElement("div", {
            className: "record-counts__counts",
        }, ...children_10);
    };
    const children_32 = [(props_17 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "mb-3"])))], (children_16 = [(children_12 = [getMaterialIcon("calculate")], react.createElement("div", {
        className: "mr-2",
    }, ...children_12)), (children_14 = [props.GetTranslation("Import.ImportProgram.Details.ImportSummary")], react.createElement("h4", {}, ...children_14))], react.createElement("div", keyValueList(props_17, 1), ...children_16))), (children_30 = [(children_22 = [(children_18 = [props.GetTranslation("Import.ImportProgram.Details.FeeTotals")], react.createElement("h5", {
        className: "mb-3",
    }, ...children_18)), (children_20 = [renderFeeTotal("New Fees", props.NewFeesTotal), renderFeeTotal("Updated Fees", props.UpdatedFeesTotal), renderFeeTotal("Consumption Fees", props.ConsumptionFeesTotal), renderFeeTotal("Total Fees", op_Addition(op_Addition(props.NewFeesTotal, props.UpdatedFeesTotal), props.ConsumptionFeesTotal))], react.createElement("div", {
        className: "split__fees",
    }, ...children_20))], react.createElement("div", {
        className: "w-100",
    }, ...children_22)), (children_28 = [(children_24 = [props.GetTranslation("Import.ImportProgram.Details.RecordCounts")], react.createElement("h5", {
        className: "mb-3",
    }, ...children_24)), (children_26 = [renderCount("New Invoicees", props.NrOfNewInvoicees), renderCount("New Contracts", props.NrOfNewContracts), renderCount("New Fees", props.NrOfNewFees), renderCount("Consumption Fees", props.NrOfConsumptionFees), renderCount("Updated Invoicees", props.NrOfUpdatedInvoicees), renderCount("Updated Contracts", props.NrOfUpdatedContracts), renderCount("Updated Fees", props.NrOfUpdatedFees), renderCount("Contract Attributes", props.NrOfContractAttributes), renderCount("Fee Attributes", props.NrOfFeeAttributes), renderCount("Updated Addresses", props.NrOfUpdatedAddresses)], react.createElement("div", {
        className: "split__record-counts",
    }, ...children_26))], react.createElement("div", {
        className: "w-100",
    }, ...children_28))], react.createElement("div", {
        className: "summary__split",
    }, ...children_30))];
    return react.createElement("div", {
        className: "file-import-details__summary",
    }, ...children_32);
}

export class DetailsProps extends Record {
    constructor(GlobalDependencies, BulkImportId) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.BulkImportId = (BulkImportId | 0);
    }
}

export function DetailsProps$reflection() {
    return record_type("Containers.FileImport.Details.View.DetailsProps", [], DetailsProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["BulkImportId", int32_type]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const reduxDispatch = useDispatch();
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const fileImportLoadState = react.useState(new LoadState$2(0));
    const newInvoiceesLoadState = react.useState(new LoadState$2(0));
    const newContractsLoadState = react.useState(new LoadState$2(0));
    const newFeesLoadState = react.useState(new LoadState$2(0));
    const consumptionFeesLoadState = react.useState(new LoadState$2(0));
    const updatedInvoiceesLoadState = react.useState(new LoadState$2(0));
    const updatedContractsLoadState = react.useState(new LoadState$2(0));
    const updatedFeesLoadState = react.useState(new LoadState$2(0));
    const contractAttributesLoadState = react.useState(new LoadState$2(0));
    const feeAttributesLoadState = react.useState(new LoadState$2(0));
    const updatedAddressesLoadStates = react.useState(new LoadState$2(0));
    const loadSingleFileImport = () => {
        loadEffect(() => loadSingleFileImport_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg) => {
            fileImportLoadState[1](arg);
        });
    };
    react.useEffect(() => {
        loadSingleFileImport();
        loadEffect(() => loadNewInvoicees_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_1) => {
            newInvoiceesLoadState[1](arg_1);
        });
        loadEffect(() => loadNewContracts_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_2) => {
            newContractsLoadState[1](arg_2);
        });
        loadEffect(() => loadNewFees_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_3) => {
            newFeesLoadState[1](arg_3);
        });
        loadEffect(() => loadConsumptionFees_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_4) => {
            consumptionFeesLoadState[1](arg_4);
        });
        loadEffect(() => loadUpdatedInvoicees_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_5) => {
            updatedInvoiceesLoadState[1](arg_5);
        });
        loadEffect(() => loadUpdatedContracts_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_6) => {
            updatedContractsLoadState[1](arg_6);
        });
        loadEffect(() => loadUpdatedFees_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_7) => {
            updatedFeesLoadState[1](arg_7);
        });
        loadEffect(() => loadContractAttributes_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_8) => {
            contractAttributesLoadState[1](arg_8);
        });
        loadEffect(() => loadFeeAttributes_1(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_9) => {
            feeAttributesLoadState[1](arg_9);
        });
        loadEffect(() => loadUpdatedAddress(props.GlobalDependencies.ClientNr, props.BulkImportId), (arg_10) => {
            updatedAddressesLoadStates[1](arg_10);
        });
    }, [props.GlobalDependencies, props.BulkImportId]);
    let summaryHtml;
    const matchValue = [fileImportLoadState[0], newFeesLoadState[0], consumptionFeesLoadState[0], updatedFeesLoadState[0]];
    let pattern_matching_result, consumptionFees, fileImportOpt, newFees, updatedFees;
    if (matchValue[0].tag === 2) {
        if (matchValue[1].tag === 2) {
            if (matchValue[2].tag === 2) {
                if (matchValue[3].tag === 2) {
                    pattern_matching_result = 0;
                    consumptionFees = matchValue[2].fields[0];
                    fileImportOpt = matchValue[0].fields[0];
                    newFees = matchValue[1].fields[0];
                    updatedFees = matchValue[3].fields[0];
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            let statisticsResult;
            if (fileImportOpt == null) {
                statisticsResult = (new FSharpResult$2(0, empty()));
            }
            else {
                const matchValue_1 = fileImportOpt.StatisticsJson;
                if (matchValue_1 == null) {
                    statisticsResult = (new FSharpResult$2(0, empty()));
                }
                else {
                    const escapedJson = matchValue_1;
                    statisticsResult = fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(StatisticsItem$reflection()), new CaseStrategy(1), void 0)), escapedJson);
                }
            }
            const getTopicValue = (name) => {
                if (statisticsResult.tag === 1) {
                    return 0;
                }
                else {
                    return getTopicValueFromStatistics(statisticsResult.fields[0], name) | 0;
                }
            };
            summaryHtml = renderSummary(new SummaryProps(getTranslation, sumBy((fee) => fee.Fee, newFees, {
                GetZero: () => (new Decimal(0)),
                Add: op_Addition,
            }), sumBy((fee_1) => fee_1.Fee, updatedFees, {
                GetZero: () => (new Decimal(0)),
                Add: op_Addition,
            }), sumBy((fee_2) => op_Multiply(fee_2.ChargePerUnit, new Decimal(toNumber_1(fee_2.ChargeUnit))), consumptionFees, {
                GetZero: () => (new Decimal(0)),
                Add: op_Addition,
            }), getTopicValue("New Invoicee"), getTopicValue("New Contracts"), getTopicValue("New Fees"), getTopicValue("New Consumption fees"), getTopicValue("Updated Invoicees"), getTopicValue("Updated Contracts"), getTopicValue("Updated Fees"), getTopicValue("Contract Attributes"), getTopicValue("Fee Attributes"), getTopicValue("Updated Addresses")));
            break;
        }
        case 1: {
            summaryHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    const children_2 = toList(delay(() => {
        let fileImport_1;
        const matchValue_2 = fileImportLoadState[0];
        return (matchValue_2.tag === 1) ? singleton(dotsLoading) : ((matchValue_2.tag === 3) ? singleton(error(matchValue_2.fields[0].split(""))) : ((matchValue_2.tag === 2) ? ((matchValue_2.fields[0] != null) ? ((fileImport_1 = matchValue_2.fields[0], append(singleton(topSection(new TopSectionProps(getTranslation, (msg_1) => {
            reduxDispatch(error_1(msg_1));
        }, locale, props.GlobalDependencies.ClientNr, props.BulkImportId, fileImport_1, () => {
            loadSingleFileImport();
        }))), delay(() => append(singleton(summaryHtml), delay(() => append(singleton(renderLoadState((newInvoicees) => renderNewInvoiceesTable(getTranslation, props.GlobalDependencies.ClientNr, props.BulkImportId, newInvoicees), newInvoiceesLoadState[0])), delay(() => append(singleton(renderLoadState((rows) => renderNewContractsTable(getTranslation, props.GlobalDependencies.ClientNr, props.BulkImportId, rows), newContractsLoadState[0])), delay(() => append(singleton(renderLoadState((rows_1) => renderNewFeesTable(getTranslation, locale, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_1), newFeesLoadState[0])), delay(() => append(singleton(renderLoadState((rows_2) => renderConsumptionFeesTable(getTranslation, locale, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_2), consumptionFeesLoadState[0])), delay(() => append(singleton(renderLoadState((rows_3) => renderUpdatedInvoiceesTable(getTranslation, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_3), updatedInvoiceesLoadState[0])), delay(() => append(singleton(renderLoadState((rows_4) => renderUpdatedContractsTable(getTranslation, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_4), updatedContractsLoadState[0])), delay(() => append(singleton(renderLoadState((rows_5) => renderUpdatedFeesTable(getTranslation, locale, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_5), updatedFeesLoadState[0])), delay(() => append(singleton(renderLoadState((rows_6) => renderContractAttributesTable(getTranslation, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_6), contractAttributesLoadState[0])), delay(() => append(singleton(renderLoadState((rows_7) => renderFeeAttributesTable(getTranslation, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_7), feeAttributesLoadState[0])), delay(() => singleton(renderLoadState((rows_8) => renderUpdatedAddressesTable(getTranslation, props.GlobalDependencies.ClientNr, props.BulkImportId, rows_8), updatedAddressesLoadStates[0])))))))))))))))))))))))))) : singleton(warning("Cannot find data for this import".split("")))) : singleton(react.createElement(react.Fragment, {}))));
    }));
    return react.createElement("div", {
        className: "file-import-details",
    }, ...children_2);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\FileImport\\Details\\View.fs", 912);

